module.exports = {"notification.message":"Wix.com utilizza i cookies per offrirti la miglior esperienza possibile.","notification.got.it":"Ok","notification.more.info":"Scopri di più","notification.got.it.arrow":"arrow icon"}


//////////////////
// WEBPACK FOOTER
// ./assets/locale/messages_it.json
// module id = 50
// module chunks = 0